const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const exportModerationPackage = async (token, data) => {
    const response = await fetch(`${API_URL}/pat-moderation/export/`, {
        method: 'POST',
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to export moderation package');
    }

    return response.json();
};

export const importModerationPackage = async (token, file, repositoryName = '1058-2025') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('repository_name', repositoryName);

    const response = await fetch(`${API_URL}/pat-moderation/import/`, {
        method: 'POST',
        headers: {
            'Authorization': `Token ${token}`,
        },
        body: formData,
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to import moderation package');
    }

    return response.json();
};

export const getModerationHistory = async (token, patAssessmentId = null) => {
    let url = `${API_URL}/pat-moderation/history/`;
    if (patAssessmentId) {
        url += `?pat_assessment_id=${patAssessmentId}`;
    }

    const response = await fetch(url, {
        headers: {
            'Authorization': `Token ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to fetch moderation history');
    }

    return response.json();
};

export const getModerationChanges = async (token, historyId) => {
    const response = await fetch(`${API_URL}/pat-moderation/history/${historyId}/changes/`, {
        headers: {
            'Authorization': `Token ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to fetch moderation changes');
    }

    return response.json();
};

export const downloadModerationPackage = async (token, filename) => {
    const response = await fetch(`${API_URL}/pat-moderation/download/${filename}/`, {
        headers: {
            'Authorization': `Token ${token}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to download moderation package');
    }

    // Convert to blob and trigger download
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
};